<app-formulario #ctrl URL="docente" titulo="Docente / Personal" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar(false);">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >

                   
                  <div formGroupName="personas_metadatos">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('dias_semanas', 'dia-semana'); ctrl.cargarCatalogo('estados', 'estados', 'municipios');  ctrl.cargarCatalogo('nacionalidades', 'nacionalidades');"></a>
                    <!-- <a id="nacimiento_municipios" (click)="ctrl.catalogoDependiente('municipios', 'nacimiento_municipios', ctrl.dato.controls.personas_metadatos.controls.nacimiento_estados_id.value)"> </a> -->
                    <a id="municipios" (click)="ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.controls.personas_metadatos.controls.estados_id.value, 'localidades')"></a>
                    <a id="localidades" (click)="ctrl.catalogoDependiente('localidades', 'localidades', ctrl.dato.controls.personas_metadatos.controls.municipios_id.value)"></a>


                    <!-- Datos Personales -->
                    <div class="content">
                        <span class="subtitle has-text-primary">
                            <i class="fa fa-home is-size-4 has-text-grey-light"> </i>
                            Datos Personales
                        </span>
                    </div>
                    <div>
                        <div class="columns">
                            <div class="column is-12" [formGroup]="dato">
                                <label class="label">Status:</label><br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="activo" name="activo" value=1 class="styled" type="checkbox" formControlName="activo">
                                        <label for="activo">
                                            Activo
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="columns" [formGroup]="dato">
                            <div class="column is-4" >
                                <div class="field">
                                    <label class="label">Nombre(s):</label>
                                    <!-- <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') }" placeholder="Nombre" formControlName="nombre">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') ">Este campo es requerido.</span>
                                    </div> -->

                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.nombre.hasError('required')}" placeholder="Nombre" formControlName="nombre">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.nombre.hasError('required') "> 
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.nombre.hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">Apellido Paterno:</label>
                                    <!-- <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('apellido_paterno').hasError('required') }" placeholder="Apellido paterno" formControlName="apellido_paterno">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('apellido_paterno').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('apellido_paterno').hasError('required') ">Este campo es requerido.</span>
                                    </div> -->

                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.apellido_paterno.hasError('required') }" placeholder="Apellido paterno" formControlName="apellido_paterno">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.apellido_paterno.hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.apellido_paterno.hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">Apellido Materno:</label>
                                    <!-- <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('apellido_materno').hasError('required') }" placeholder="Apellido Materno" formControlName="apellido_materno">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('apellido_materno').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('apellido_materno').hasError('required') ">Este campo es requerido.</span>
                                    </div> -->

                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.apellido_materno.hasError('required') }" placeholder="Apellido Materno" formControlName="apellido_materno">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.apellido_materno.hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.apellido_materno.hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-3">
                                <div class="field">
                                    <label class="label">Fecha Nacimiento</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [textMask]="{mask:mask, keepCharPositions: true, pipe: autoCorrectedDatePipe}" [ngClass]="{'is-danger': !ctrl.dato.controls.personas_metadatos.get('fecha_nacimiento').valid }" placeholder="2000-12-02" formControlName="fecha_nacimiento">
                                        <span class="icon is-small is-right" *ngIf="!ctrl.dato.controls.personas_metadatos.get('fecha_nacimiento').valid ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('fecha_nacimiento').hasError('required') ">Este campo es requerido.</span>
                                        <span class="help is-danger" *ngIf="!ctrl.dato.controls.personas_metadatos.get('fecha_nacimiento').valid">Debe tener formato: AAAA-MM-DD.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-3" [formGroup]="dato">
                                <label class="label">Sexo:</label><br>
                                <!-- <div class="field">
                                    <div class="b-checkbox is-info is-circular">
                                        <input id="sexo_f" name="sexo" value="F" class="styled" type="radio" formControlName="sexo">
                                        <label for="sexo_f">
                                            Femenino
                                        </label>

                                        <input id="sexo_m" name="sexo" value="M" class="styled" type="radio" formControlName="sexo">
                                        <label for="sexo_m">
                                            Masculino
                                        </label>
                                    </div>
                                </div> -->

                                <div class="field">
                                    <div class="b-checkbox is-info is-circular">
                                        <input id="sexo_f" name="sexo" value="F" class="styled" type="radio" formControlName="sexo">
                                        <label for="sexo_f">
                                            Femenino
                                        </label>

                                        <input id="sexo_m" name="sexo" value="M" class="styled" type="radio" formControlName="sexo">
                                        <label for="sexo_m">
                                            Masculino
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-3">
                                <label class="label">Estado civil:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" name="estado_civil" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('estado_civil').hasError('required') }" formControlName="estado_civil">
                                            <option value="1" >Soltero(a)</option>
                                            <option value="2" >Casado(a)</option>
                                            <option value="3" >Viudo(a)</option>
                                            <option value="4" >Divorciado(a)</option>
                                            <option value="5" >Unión libre</option>
                                            <option value="6" >Comprometio(a)</option>
                                        </select>
                                    </div>
                                </div>
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('estado_civil').hasError('required')">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('estado_civil').hasError('required')">Este campo es requerido.</span>
                            </div>
                            <div class="column is-3">
                                <label class="label">Nacionalidad:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="nacionalidades_id" >
                                            <option *ngFor="let item of ctrl.nacionalidades" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacionalidades_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacionalidades_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="columns">
                            <div class="column is-6">
                                <label class="label">Estado de nacimiento:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="nacimiento_estados_id" (change)="ctrl.catalogoDependiente('municipios', 'nacimiento_municipios', ctrl.dato.controls.personas_metadatos.controls.nacimiento_estados_id.value)">
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let item of ctrl.nacimiento_estados" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacimiento_estados_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacimiento_estados_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                            </div>

                            <div class="column is-6">
                                <label class="label">Municipio de nacimiento:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="nacimiento_municipios_id" >
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let item of ctrl.nacimiento_municipios" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacimiento_municipios_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('nacimiento_municipios_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                            </div>
                        </div> -->
                        <div class="columns">
                            <div class="column is-3" [formGroup]="dato">
                              <div class="field">
                                <label class="label">Email:</label>
                                <div class="control is-expanded  has-icon has-icon-left">
                                  <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('email').hasError('required') }"
                                    placeholder="Email" formControlName="email">
                                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('email').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                  </span>
                                  <span class="help is-danger" *ngIf="ctrl.dato.get('email').hasError('email') ">Error de formato email correo@dominio.mx</span>
                                  <span class="help is-danger" *ngIf="ctrl.dato.get('email').hasError('unique') ">Este email ya está registrado.</span>
                                </div>
                              </div>
                            </div>
                            <div class="column is-3" [formGroup]="dato">
                              <div class="field">
                                <label class="label">Usuario:</label>
                                <div class="control is-expanded  has-icon has-icon-left">
                                  <input class="input" type="text" placeholder="Inicio de sessión" formControlName="username">
                                </div>
                              </div>
                            </div>
                            <div class="column is-3" [formGroup]="dato">
                                <div class="field">
                                    <label class="label">CURP:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" placeholder="CURP" formControlName="curp" maxlength="18">
                                        <span class="icon is-small is-right" *ngIf="!ctrl.dato.controls.curp.valid ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.curp.hasError('required')">Este campo es requerido.</span>
                                        <span class="help is-danger" *ngIf="!ctrl.dato.controls.curp.valid">Longitud esperada: 18 caracteres.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-3">
                                <div class="field">
                                    <label class="label">Teléfono de contacto:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" placeholder="Teléfono de contacto" formControlName="telefono_contacto">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Domicilio Actual -->
                    <div class="content">
                        <hr>
                        <span class="subtitle has-text-primary">
                            <i class="fa fa-globe is-size-4 has-text-grey-light"> </i>
                            Domicilio Actual
                        </span>
                    </div>
                    <div>
                        <div class="columns">
                            <div class="column is-4">
                                <label class="label">Estado:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="estados_id" (change)="ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.controls.personas_metadatos.controls.estados_id.value)">
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let item of ctrl.estados" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('estados_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('estados_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                            </div>

                            <div class="column is-4">
                                <label class="label">Municipio:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="municipios_id" (change)="ctrl.catalogoDependiente('localidades', 'localidades', ctrl.dato.controls.personas_metadatos.controls.municipios_id.value)">
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let item of ctrl.municipios" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('municipios_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('municipios_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                            </div>

                            <div class="column is-4">
                                <label class="label">Localidad:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="localidades_id" >
                                            <option value="">Seleccione</option>
                                            <option *ngFor="let item of ctrl.localidades" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('localidades_id').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('localidades_id').hasError('required') ">Este campo es requerido.</span>
                                </div>
                                <!--<span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('localidades_id').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('localidades_id').hasError('required') ">Este campo es requerido.</span>-->
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Colonia:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('colonia').hasError('required') }" placeholder="Colonia" formControlName="colonia">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('colonia').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('colonia').hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <label class="label">Calle:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('calle').hasError('required') }" placeholder="Calle" formControlName="calle">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('calle').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('calle').hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">No. ext:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('no_exterior').hasError('required') }" placeholder="#" formControlName="no_exterior">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('no_exterior').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('no_exterior').hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">No.interiror:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('no_interior').hasError('required') }" placeholder="#" formControlName="no_interior">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('no_interior').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('no_interior').hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <label class="label">Código postal:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('codigo_postal').hasError('required') }" placeholder="Cp" formControlName="codigo_postal">
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('codigo_postal').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('codigo_postal').hasError('required') ">Este campo es requerido.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Documentos -->
                    <div class="content">
                        <hr>
                        <span class="subtitle has-text-primary">
                            <i class="fa fa-file is-size-4 has-text-grey-light"> </i>
                            Documentos
                        </span>
                    </div>
                    <div>
                        <div class="columns">
                            <div class="column is-8">
                                <label class="label">Preparatoria</label>
                            </div>
                            <div class="column is-4">
                                <label class="label">Tipo de beca</label>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-4">
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="acta_nacimiento" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').patchValue(ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').value == '1' ? '0' : '1')"
                                        type="checkbox">
                                        <label for="acta_nacimiento">
                                            Acta de nacimiento
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="curp_impreso" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('curp_impreso').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('curp_impreso').patchValue(ctrl.dato.controls.personas_metadatos.get('curp_impreso').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="curp_impreso">
                                            CURP
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="certificado_preparatoria" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('certificado_preparatoria').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('certificado_preparatoria').patchValue(ctrl.dato.controls.personas_metadatos.get('certificado_preparatoria').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="certificado_preparatoria">
                                            Certificado de preparatoria
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="certificado_legalizado" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('certificado_legalizado').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('certificado_legalizado').patchValue(ctrl.dato.controls.personas_metadatos.get('certificado_legalizado').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="certificado_legalizado">
                                            Certificado legalizado
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="certificado_medico" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('certificado_medico').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('certificado_medico').patchValue(ctrl.dato.controls.personas_metadatos.get('certificado_medico').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="certificado_medico">
                                            Certificado médico
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="carta_conducta" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('carta_conducta').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('carta_conducta').patchValue(ctrl.dato.controls.personas_metadatos.get('carta_conducta').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="carta_conducta">
                                            Carta de buena conducta
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="historial_academico" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('historial_academico').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('historial_academico').patchValue(ctrl.dato.controls.personas_metadatos.get('historial_academico').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="historial_academico">
                                            Historial académico
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="fotografias" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('fotografias').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('fotografias').patchValue(ctrl.dato.controls.personas_metadatos.get('fotografias').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="fotografias">
                                            4 fotografías
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-4">
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="beca_convenio" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('beca_convenio').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('beca_convenio').patchValue(ctrl.dato.controls.personas_metadatos.get('beca_convenio').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="beca_convenio">
                                            Convenio
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <div class="b-checkbox is-info">
                                        <input id="beca_promedio" class="styled" [checked]="ctrl.dato.controls.personas_metadatos.get('beca_promedio').value == '1' ? true : false" (change)="ctrl.dato.controls.personas_metadatos.get('beca_promedio').patchValue(ctrl.dato.controls.personas_metadatos.get('beca_promedio').value == '1' ? '0' : '1')"
                                            type="checkbox">
                                        <label for="beca_promedio">
                                            Promedio
                                        </label>
                                    </div>
                                </div>
                                <br>
                                <div class="field">
                                    <label class="label">Observaciones:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                        <input class="input" type="text" placeholder="Observaciones" formControlName="documentos_observaciones">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>

                  <div>
                    <!-- Disoponibilidad horario -->
                    <div class="content">
                      <hr>
                      <span class="subtitle has-text-primary">
                          <i class="fa fa-clock-o is-size-4 has-text-grey-light"> </i>
                          Disponibilidad de horario
                      </span>
                      <span class="is-pulled-right"	>
                        <button type="button" class="button btn-lg is-success" (click)="ctrl.agregar_form_array(ctrl.dato.controls.disponibilidades_horarios_docentes, form_disponibilidades_horarios_docentes)">
                          <i class="icon-add"></i> &nbsp; &nbsp;  Agregar Hora
                        </button>
                      </span>
                    </div>
                    <div>

                        <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('disponibilidades_horarios_docentes').length > 0">
                            <thead>
                                <tr>
                                    <th hide-sm>ID</th>
                                    <th>Día</th>
                                    <th>Hora inicial</th>
                                    <th>Hora final</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody formArrayName="disponibilidades_horarios_docentes">
                                <tr *ngFor="let medio of ctrl.dato.controls.disponibilidades_horarios_docentes.controls; let suc=index" [formGroupName]="suc">
                                    <td>{{ suc + 1 }}</td>
                                    <td>
                                        <div class="select">
                                            <select class="select" name="dias_semanas_id" formControlName="dias_semanas_id">
                                                <option *ngFor="let val of ctrl.dias_semanas" value="{{val.id}}">{{ val.nombre }}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <p class="control has-icon">
                                            <input class="input" formControlName="hora_inicial" placeholder="Hora inicial" [ngClass]="{'is-danger': !ctrl.dato.controls.disponibilidades_horarios_docentes.controls[suc].controls.hora_inicial.valid}"
                                                type="time" step="10">
                                            <span class="icon">
                                                <i class="fa fa-calendar"></i>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="control has-icon">
                                            <input class="input" formControlName="hora_final" placeholder="Hora final" [ngClass]="{'is-danger': !ctrl.dato.controls.disponibilidades_horarios_docentes.controls[suc].controls.hora_final.valid}"
                                                type="time" step="10">
                                            <span class="icon">
                                                <i class="fa fa-calendar"></i>
                                            </span>
                                        </p>
                                    </td>
                                    <td align="right">
                                        <button type="button" class="button pull-right is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.disponibilidades_horarios_docentes, suc)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                            <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.disponibilidades_horarios_docentes, form_disponibilidades_horarios_docentes)">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div> -->

                    </div>

                  </div>
                  <div>
                    <!-- Materias del perfil -->
                    <div class="content">
                      <hr>
                      <span class="subtitle has-text-primary">
                          <i class="icon-book is-size-4 has-text-grey-light"> </i>
                          Materias del perfil
                      </span>
                      <!-- <span class="is-pulled-right"	>
                        <button type="button" class="button btn-lg is-success" (click)="ctrl.agregar_form_array(ctrl.dato.controls.docentes_perfiles_materias, form_docentes_perfiles_materias)">
                          <i class="icon-add"></i> &nbsp; &nbsp;  Agregar nueva Materia
                        </button>
                      </span> -->
                    </div>
                    <div>

                      <div class="columns">
                        <div class="field column is-6">
                            <div class="select">
                              <select class="select" name="carreras_planes_id" (change)="filtra_niveles(); filtra_materias();" formControlName="carreras_planes_id">
                                  <option *ngFor="let val of carreras_planes" value="{{val.id}}">{{ val.text }}</option>
                              </select>
                            </div>
                        </div>
                        <div class="field column is-6">
                            <div class="select">
                              <select class="select" name="nivel" formControlName="nivel" (change)="filtra_materias();">
                                  <option *ngFor="let val of niveles" value="{{val.id}}">{{ val.texto }}</option>
                              </select>
                            </div>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="field column is-6">
                          <div class="select">
                            <select class="select" name="materias_id" formControlName="materias_id">
                                <option *ngFor="let val of materias" value="{{val.id}}">{{ val.nombre }} - {{ val.clave }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="field column is-6">
                          <span class="is-pulled-right"	>
                              <button type="button" class="button btn-lg is-success" (click)="agregar_form_array(ctrl.dato.controls.docentes_perfiles_materias, form_docentes_perfiles_materias, materias? materias : [])" [disabled]="ctrl.dato.controls.materias_id.value==''">
                                <i class="icon-add"></i> &nbsp; &nbsp;  Agregar Materia
                              </button>
                            </span>
                        </div>
                      </div>



                        <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('docentes_perfiles_materias').length > 0">
                            <thead>
                                <tr>
                                    <th hide-sm>ID</th>
                                    <th>Materia</th>
                                    <th>Carrera/Plan</th>
                                    <th>Nivel</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody formArrayName="docentes_perfiles_materias">
                                <tr *ngFor="let mat of ctrl.dato.controls.docentes_perfiles_materias.controls; let suc=index" [formGroupName]="suc">
                                    <td>{{ suc + 1 }}</td>
                                    <td>
                                        <h3> {{ mat.value.nombre }} <strong> {{ mat.value.clave }} </strong> </h3>
                                    </td>
                                    <td>{{ mat.value.materias?.carreras_planes.planes_estudios.nombre }} - {{ mat.value.materias?.carreras_planes.carreras.nombre }}</td>
                                    <td> {{ mat.value.materias.nivel }} </td>
                                    <td align="right">
                                        <button type="button" class="button pull-right is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.docentes_perfiles_materias, suc)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                            <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.docentes_perfiles_materias, form_docentes_perfiles_materias)">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div> -->

                    </div>
                  </div>

                  <br>
                  <br>
                </section>
            </form>
        </div>
    </div>
</div>
